
const digest = 'aee72de2dbf1645e4df319f55a458e15894e80918cd82b7184e783ad58c41ca6';
const classes = {"wrapper":"_wrapper_1ixl4_1"};
const css = `._wrapper_1ixl4_1 {
  font-family: Rubik, "sans-serif";
  font-size: 14px;
  font-weight: 500;
  color: #d81616;
  margin: 10px 0;
  padding: 12px 24px;
  display: flex;
  align-items: center;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  